const React = require("react");

function CheckCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "check-circle",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "15.9,8.3 10.9,16.2 8.1,12.7 "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }));
}

module.exports = CheckCircleIcon;